import { parseJsonOrYaml as i } from "@scalar/oas-utils/helpers";
const f = (r) => {
  if (r)
    return typeof r == "function" ? f(r()) : typeof r == "string" ? i(r) : r || void 0;
};
export {
  f as normalizeContent
};
